import { connect } from 'react-redux'
import { contactInfo, gdprAgreements } from './reducer'

const mapStateToProps = (state) => {
    return {
        firstname: state?.services?.user?.firstname,
        lastname: state?.services?.user?.lastname,
        phone: state?.services?.user?.phone,
        email: state?.services?.user?.email,

        isPersonalGDPR: state?.services?.user?.loyalty_program?.gdpr_non_personal,
        isNonPersonalGDPR: state?.services?.user?.loyalty_program?.gdpr_personal,
    }
}

const mapDispatchToProps = { contactInfo, gdprAgreements }

const hocFormContactInfo = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocFormContactInfo
